/**
 * /tenants/$slug/authentication — index redirect.
 *
 * The hub has no standalone landing of its own; bare /authentication redirects to the
 * Sign-in tab so the layout's <Outlet/> is never empty (and so the sidebar entry, which
 * targets sign-in, and any hand-typed /authentication URL both resolve somewhere real).
 */

import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/tenants/$slug/authentication/sign-in",
      params: { slug: params.slug },
    });
  },
});
